import { COLORS } from '@constants';
import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
`;

export const ScrollContainer = styled.div`
    max-height: 250px;
    overflow: auto;
    /* For WebKit browsers (Chrome, Safari) */
    /* Track */
    ::-webkit-scrollbar {
        width: 4px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background-color: ${COLORS.$gray40Black};
        border-radius: 6px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background-color: ${COLORS.$gray60Black};
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: ${COLORS.$gray20Black};
    }
`;

export const StyledListItem = styled.div`
    padding: 12px 12px 12px 0;
    border-bottom: 1px solid ${COLORS.$gray15Black};
`;

export const StyledListContainer = styled.div`
    background: ${COLORS.$white};
    padding: 48px 24px;
    max-width: 632px;
    border-radius: 8px;
`;
